import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Billing } from '../../../../pages/settings/Billing';

export const Route = createFileRoute('/_private/_home/settings/billing')({
  component: BillingRoute,
});

function BillingRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Billing portalApiClient={apiClient} />;
}
